import { ConfigProvider } from 'antd';
import { BrowserRouter } from 'react-router-dom';
import { AppRouter } from './router';
import { antdTheme } from './theme';

function App() {
  return (
    <ConfigProvider theme={antdTheme}>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
